import './css/style.css'
import './css/overwrites.css'

export const lazyContent = new LazyLoad({
    use_native: false
});

import LazyLoad from "vanilla-lazyload";
import 'preline'
import '@preline/select'

import './ts/handle-trade-values'
import './ts/formatters'
import './ts/handle-mobile-nav'
import './ts/handle-scroll-spy'
import './ts/handle-scroll-to'
import './ts/handle-show-hide-car-make-model'
import './ts/handle-show-more'
import './ts/Cars4SalePage'
import './ts/handle-toggle-car-favourite'
import './ts/handle-submit-loan'
import './ts/handle-detail-swipers'
import './ts/handle-filters'
import './ts/standard-lead-submission'

import './ts/InputMask'
import './ts/RangeSlider'
import './ts/toggle'
import './ts/SimpleWizard'
import './ts/SimpleModal'
import './ts/SearchRates'
import './ts/sync-text'
import './ts/check-credit'

import '/src/js/htmx.min.js'
